<template>
  <!-- Cancel Policy Dialog -->

  <div class="cancel-steps">
    <div class="p-3 font-bold">
      <span class="text-red-500 el-icon-delete-solid" data-test="cancellationTitle" />
      Policy Cancellation
    </div>

    <component
      :is="activeStepComponent"
      ref="step"
      :reason="reason"
      @reason="reason = $event"
      @success="enable"
    />

    <div class="flex">
      <div class="flex flex-1 label mr-2 self-end">
        <label class="text-xs" data-test="cancellationStep">
          Step {{ step + 1 }} of {{ stepNames.length }}
        </label>
      </div>

      <!-- Buttons -->
      <div class="flex justify-end">
        <el-button
          v-if="!isLast"
          :disabled="!enableNext"
          type="primary"
          size="mini"
          data-test="cancellationNextButton"
          @click.native="next($event)"
        >
          Next
        </el-button>
        <el-button
          v-else
          type="danger"
          :disabled="!enableNext"
          size="mini"
          data-test="cancellationCancelButton"
          @click="cancel"
        >
          Cancel Policy
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import CancelStep1Vue from "./cancel-steps/CancelStep1.vue";
import CancelStep2Vue from "./cancel-steps/CancelStep2.vue";
import CancelStep3Vue from "./cancel-steps/CancelStep3.vue";
export default {
  components: {
    Reason: CancelStep1Vue,
    Upload: CancelStep2Vue,
    Sign: CancelStep3Vue
  },
  props: {
    visible: [String, Boolean],
    autoCancel: {
      type: [Boolean, String],
      default: false
    },
    step: {
      type: [String, Number],
      default: 0
    }
  },
  data: () => ({
    // step:       0,
    reason: null,
    enableNext: false
  }),
  computed: {
    value: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },

    stepNames() {
      const code = this.reason?.reasonCode;

      if (this.autoCancel) {
        return ["Sign"];
      }

      if (code === "13") {
        return ["Sign"];
      }

      const steps = ["Reason", "Upload", "Sign"];

      if (!this.reason?.policyCancelDocs?.length) {
        // steps.splice(1, 1)
      }

      return steps;
    },

    autoCancelPayload() {
      return {
        PolicyNumber: this.$store.getters["policy/allData"].policyNo,
        ReasonCode: 13,
        NoteInfo: {
          Note: "",
          Private: false
        },
        EffectiveDate: new Date().toISOString()
      };
    },

    activeStepComponent() {
      return this.stepNames[this.step];
    },

    isLast() {
      return this.step === this.stepNames.length - 1;
    }
  },
  watch: {
    step(val, oldVal) {
      if (val > oldVal) {
        this.enableNext = false;
      }
    }
  },
  beforeMount() {
    /** @type {neptune.getters.IRootGetters} */
    const { "policy/cancelReason": reason } = this.$store.getters;

    this.reason = reason;
  },
  methods: {
    reset() {
      this.step = 0;
    },
    refreshPolicy() {
      this.$store.dispatch(
        "policy/getPolicyDetails",
        this.$store.getters["policy/allData"].policyNo
      );
    },
    enable(val) {
      this.enableNext = val;
    },

    /** @param {MouseEvent} ev */
    async submit(ev) {
      this.enableNext = false;
      /** @type {Vue} */
      const currentComponent = this.$refs.step;

      const hasSubmit = !!currentComponent.$options.methods.submit;

      if (hasSubmit && !ev.ctrlKey) {
        try {
          const val = await currentComponent.submit();
          this.enableNext = true;
          return val;
        } catch (error) {
          this.enableNext = true;
          return Promise.reject(new Error(error));
        }
      } else {
        this.enableNext = true;
        return true;
      }
    },
    prev() {
      this.step -= 1;
    },
    async next(ev) {
      await this.submit(ev);
      this.refreshPolicy();
      this.$emit("update:step", this.step + 1);
    },
    async cancel(ev) {
      await this.submit(ev);
      this.refreshPolicy();
      this.$emit("cancel");
    },
    async cancelPolicy() {
      try {
        return this.$store.dispatch("policy/cancelPolicy", this.autoCancelPayload);
      } catch (error) {
        this.$msgbox({
          title: "Error",
          type: "error",
          message: error
        }).catch(() => {});

        return error;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .cancel-dialog {
  .el-dialog__body {
    background-color: #f5f5f5;
  }
}
</style>
